<template>
  <div>
    <BCard
      v-if="!isEmpty(information)"
      class="border rounded-lg"
    >
      <template #header>
        <div class="text-black font-semibold text-xl">
          Informasi
        </div>
      </template>
      <BCol
        cols="6"
        class="p-0"
      >
        <BOverlay
          :show="loading"
          spinner-variant="primary"
          variant="light"
          class="mt-[16px]"
          blur="0"
          opacity=".5"
          rounded="sm"
        >
          <div class="border-x-2 border-b-2 p-[10px] rounded-lg">
            <div
              v-for="row in information"
              :key="row.label"
              class="flex items-start gap-2 mb-[10px]"
            >
              <div class="w-48 text-[#626262]">
                {{ row.label }}
              </div>
              <div class="w-2 text-center text-black">
                :
              </div>

              <div
                class="flex-1 text-black font-medium"
                v-html="row.value"
              />
            </div>
          </div>
        </BOverlay>
      </BCol>
    </BCard>
  </div>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import isEmpty from 'lodash/isEmpty'

export default {
  data() {
    return {
      IDR,
      isEmpty,
      loading: false,
      information: null,
    }
  },
  mounted() {
    this.getInformation()
  },
  methods: {
    async getInformation() {
      this.loading = true
      try {
        const { id } = this.$route.params
        const url = `/komcards/api/v1/user/${id}/information`
        const { data: { data } } = await newAxiosIns.get(url)

        const formattedData = [
          { label: 'Total Spending', value: IDR(data.total_spending) },
          { label: 'Total Kartu', value: `${data.card.total_usage}/${data.card.total_quota}` },
          { label: 'Platinum', value: data.card.total_platinum },
          { label: 'Gold', value: data.card.total_gold },
          { label: 'Kartu Aktif', value: `${data.card.total_active}/${data.card.total_usage} <span class="text-[#34A770]">(${Math.round(data.card.percentage_active)}%)</span>` },
          { label: 'Kartu Minus', value: `${data.card.total_minus}/${data.card.total_usage} <span class="text-[#E31A1A]">(${IDR(data.card.total_negative_balance)})</span>` },
        ]
        this.information = formattedData
        this.loading = false
      } catch {
        this.$toast_error({ message: 'Gagal load data information' })

        this.loading = false
      }
    },
  },
}
</script>
